export const getIsRecognizedHeaderPredicate = (header: string) => (recHeading: string) =>
  header.toLowerCase().includes(recHeading);

export const recognizedGroupNumberHeadings = [
  'group-number',
  'group number',
  'groupnumber',
  'varugrupp',
  'varu-grupp',
  'varegruppe',
  'vare-gruppe',
  'vare gruppe',
];
export const recognizedDiscountCodeHeadings = [
  'group-codes',
  'group codes',
  'groupcodes',
  'groupcode',
  'rabattgrupp',
  'rabatt grupp',
  'rabatt-grupp',
  'rabattgruppe',
  'rabatt-gruppe',
  'rabatt gruppe',
];
export const recognizedCustomerFactorHeadings = [
  'customer-factor',
  'customerfactor',
  'customer factor',
];
